import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=e27d661c"
import script from "./admin.js?vue&type=script&lang=js&external"
export * from "./admin.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports